var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-close-icon-container",on:{"click":function($event){return _vm.$emit('close-toast')}}},[_c('img',{attrs:{"src":require("@/assets/Close_Line_18px_2_Icon_black.svg"),"height":"14","width":"14"}})])}
var staticRenderFns = []

export { render, staticRenderFns }